import {Breadcrumb} from '@opten/breadcrumb';
import { Component } from '@opten/compiler/metadata/component';
@Component({ className: 'js-breadcrumb' })
export class BreadcrumbComponent {
    constructor(private element: HTMLElement) {
        new Breadcrumb(element, {
            breakpoints: {
                maxWidth: 1024
            }
        });
    }
}